import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createUserReceiptSlice = (set, get) => ({
    crmUserReceipt: {
        loading: false,
        data: []
    },
    getUserReceipt: async (usrUserID) => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ crmUserReceipt: { ...state.crmUserReceipt, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/insurance/crm/user/${usrUserID}/receipt`,
                headers: { token }
            });
            set(state => ({ crmUserReceipt: { loading: false, data: resp.data } }));
        } catch (error) {
            set(state => ({ crmUserReceipt: { loading: false, data: [] } }));
        }
    }
});
